import { Controller } from '@hotwired/stimulus'

// Off-canvas admin sidebar for small screens. On lg+ the sidebar is static
// (lg:translate-x-0), so these toggles are a no-op there.
export default class extends Controller<HTMLElement> {
  static targets = ['sidebar', 'backdrop']

  declare readonly sidebarTarget: HTMLElement
  declare readonly backdropTarget: HTMLElement

  open(): void {
    this.sidebarTarget.classList.remove('-translate-x-full')
    this.sidebarTarget.classList.add('translate-x-0')
    this.backdropTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close(): void {
    this.sidebarTarget.classList.add('-translate-x-full')
    this.sidebarTarget.classList.remove('translate-x-0')
    this.backdropTarget.classList.add('hidden')
    document.body.style.overflow = ''
  }

  toggle(): void {
    if (this.sidebarTarget.classList.contains('-translate-x-full')) {
      this.open()
    } else {
      this.close()
    }
  }
}
